/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'
import React from 'react'
import { Loading, show, cleanObject } from '../../twd'
import useRecentSearches from './use-recent-searches'

export default ({dataName = 'recent-searches'} = {}) => {

    const { status, recentSearches } = useRecentSearches()

    return <React.Fragment>
        <div className="vertical-offset-sm"></div>
        <div data-name={dataName} className="container vertical-offset-sm" css={sectionCss}>
            <div className="row vertical-offset-sm"></div>

            <div className="row"><div className="col-xs-12">
                <h6 className="sub-head">Recent Searches</h6>
            </div></div>

            <div className="row vertical-offset-xs">
            <div className="col-xs-12 text-truncate">
            <Loading status={status}>
            {
                recentSearches.map( (a,i) => (
                    <React.Fragment key={i}>
                    <div
                        data-name={dataName + '-row'}
                        className="link-button text-truncate vertical-offset-xs"
                        style={{display:'block'}}
                        item={a}
                        onClick={() => onSearch(a)}>
                        {a.description}
                    </div>
                    </React.Fragment>
                ))
            }
            </Loading>
            </div></div>

        </div>
        </React.Fragment>
}

const onSearch = ({searchParams}) => {
    show('offerings', Object.assign({
        searchParams: cleanObject(Object.assign(searchParams, {persistToPreviousSearches: false})),
        _ts: Date.now(),
        from: 'advanced-screener'
    }))
}

